import React, { useEffect, useMemo } from 'react';
import ReadyProposalActions from 'components/generate-proposal/ReadyProposalActions';
import { useProposalUrlParams } from 'global/hooks/useProposalUrlParams';
import ProposalReadyPageStore, {
  ProposalReadyPageStoreContext,
  useProposalReadyPageStore,
} from 'store/pages/proposal-generation/proposalReadyPageStore';
import { observer } from 'mobx-react-lite';
import ProposalStatusLayout from 'components/common/proposal/ProposalStatusLayout';
import { PageHeader } from '@insurancemenu/imenu-components-lib';
import { PageWrapperStyled } from '../../../globalStyles';

/* TESTING_POLICY: CYPRESS_ONLY */

const PageContent: React.FC = observer(() => {
  const { redirectBack, getInitialData } = useProposalReadyPageStore();

  useEffect(() => {
    void getInitialData();
  }, []);

  return (
    <ProposalStatusLayout>
      <PageWrapperStyled>
        <PageHeader title="Proposal Generation" onBackButtonClick={redirectBack} />
        <ReadyProposalActions />
      </PageWrapperStyled>
    </ProposalStatusLayout>
  );
});

const ProposalReadyPage: React.FC = () => {
  const { url, cartId, groupId, catalogId, periodId, proposalType, cartName } = useProposalUrlParams();

  const store = useMemo(
    () =>
      new ProposalReadyPageStore({
        url,
        cartId,
        groupId,
        catalogId,
        enrollmentPeriodId: periodId,
        proposalType,
        cartName,
      }),
    [],
  );
  return (
    <ProposalReadyPageStoreContext.Provider value={store}>
      <PageContent />
    </ProposalReadyPageStoreContext.Provider>
  );
};

export default ProposalReadyPage;
